import funcion from './funcion/funcion'

const firmaelectronica = {
  funcion: funcion
}

export default firmaelectronica;



//////////////////
// WEBPACK FOOTER
// ./static/js/api/firmaelectronica/firmaelectronicaapi.js
// module id = null
// module chunks = 